export default class InvalidTokenError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}
